import { Lock, ChevronRight } from "lucide-react";

/**
 * LockedPlaceholder
 * Shown when a tab requires completed onboarding to access.
 *
 * Props:
 *   title – heading text
 *   desc  – supporting description
 */
export default function LockedPlaceholder({ title, desc }) {
  return (
    <div className="placeholder-box" style={{ marginTop: 8 }}>
      <div className="placeholder-icon" style={{ background: "#fef9c3" }}>
        <Lock size={26} color="#ca8a04" />
      </div>
      <div className="placeholder-title">{title}</div>
      <p className="placeholder-desc">{desc}</p>
      <button
        className="btn btn-primary"
        onClick={() => window.location.href = "/onboarding"}
      >
        Complete Onboarding <ChevronRight size={14} />
      </button>
    </div>
  );
}